/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useCallback, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
// import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import HeadPage from '@/components/Common/Head';
import { CenterBox, LeftBox, RightBox } from '@/components/CommandCenter';
import useMeta from '@/hooks/useMeta/useMeta';
import styles from '@/styles/pages/Tasks/Tasks.module.scss';
import EarlyAccessTelegram from '@/components/CommandCenter/Modals/EarlyAccessTelegram';
import useTranslationStatus from '@/hooks/useTranslationStatus';
import useResponsive from '@/hooks/useResponsive';

const Achievements = ({ commandCenterBar }) => {
  const router = useRouter();
  const metaTags = useMeta(router.pathname);
  const { isReady } = useTranslationStatus();
  const pointListRef = useRef(null);
  const { isMobile } = useResponsive();
  // let intro: Tour;
  // if (typeof window !== 'undefined') {
  //   intro = introJs.tour(); // Create a single instance of introJs
  // }

  // Onboarding steps configuration with custom inline styles
  // const steps: Partial<any>[] = [
  // {
  //   // element: '#test-2',
  //   element: '#step0',
  //   intro: `Congratulations, comrade! You successfully completed your first command. Now it's time to claim your rewards!. just Click "Let's go"!`,
  //   position: 'right',
  //   tooltipClass: 'customTooltipStyle', // Define a custom class for tooltip styling
  //   highlightClass: 'customHighlightStyle',
  // },
  // {
  //   // element: '#step0',
  //   intro:
  //     "Congratulations on joining our ranks! You've just completed your first command. Go ahead and claim your reward of 500 LRT tokens—your journey to glory and rewards has officially begun!",
  //   position: 'right', // Change the position to 'top'
  //   tooltipClass: 'customTooltipStyle',
  //   highlightClass: 'customHighlightStyle',
  // },
  // {
  // element: '#step0',
  //   intro: "“Now it's time to open your first command and claim your well-earned reward. Let's get those 500 LRT tokens!",
  //   position: 'right', // Ensure the position is 'top' for consistency
  //   tooltipClass: 'customTooltipStyle',
  //   highlightClass: 'customHighlightStyle',
  // },

  // {
  //   element: '#final-step',
  //   intro: "You're almost done! Just a few more steps to complete.",
  //   position: 'right', // Adjust the position
  //   tooltipClass: 'customTooltipStyle',
  //   highlightClass: 'customHighlightStyle',
  // },
  // ];

  // const stepFour: Partial<any>[] = [
  //   {
  //     element: '#step1',
  //     intro: 'Here’s your second command—get ready to tackle it and earn even more rewards!',
  //     position: 'right', // Ensure the position is 'top' for consistency
  //     tooltipClass: 'customTooltipStyle',
  //     highlightClass: 'customHighlightStyle',
  //   },
  // ];

  // Inline styles (added in a style tag or in CSS file)
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .customTooltipStyle {
        background: linear-gradient(328deg, rgba(25,40,44,1) 0%, rgba(9,24,29,1) 100%);
        color: white;
        padding: 6px;
        border-radius: 5px;
        min-width:${isMobile ? '300px' : '400px'};
        border-radius:14px;
      }
      .customHighlightStyle {
        box-shadow: rgba(250, 250, 250, 0.2) 0px 0px 0px 5000px !important;
        border-radius:8px;
      }
      .introjs-skipbutton{
        width:24px;
        height:24px;
        border-radius:8px;
        border:1px solid white;
        color:white;
        font-size:18px;
        line-height:1.1;
        top:4px;
        right:4px;

      }
        .introjs-skipbutton:hover{
        color:white;
        }

      .introjs-disableInteraction{
        border-radius:8px;
      }
        .introjs-tooltipbuttons{
          border-top:0px
        }
      .introjs-tooltipbuttons{
      display:flex;
      justify-content:end;
      }
      .introjs-nextbutton{
        background:#47FEFF !important;
        color:#000000 !important;
        border-radius:6px !important;
        text-shadow:0px 0px 0 #000000;
        border:0px;
      }
      .introjs-prevbutton{
      background:transparent !important;
      color:#47FEFF !important;
      text-shadow:0px 0px 0 #000000;
      border:0px;
      }

      .introjs-disabled{
        color:#919191 !important;
        margin-right: 10px;
      }

      .introjs-button:focus{
        box-shadow:0px 0px 0 !important
        border:0px;
      }
        .introjs-bullets{
        position: absolute;
        bottom: 14px;
        left: 26px;
        }

        .introjs-tooltiptext{
        padding:${isMobile ? '8px' : '14px'};
        font-size:${isMobile ? '12px !important;' : '18px;'}
        }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, [isMobile]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (router.query.taskId === undefined && router.query.isonboarding === 'step-two' && isLogin) {
  //       intro
  //         .setOptions({
  //           steps,
  //           exitOnOverlayClick: false, // Prevent closing on outside click
  //           showBullets: true, // Example of another option
  //           disableInteraction: true, // Prevent interaction with the rest of the page
  //           doneLabel: `Let's go`,
  //         })
  //         .onStart(() => {
  //           if (steps.at(0)) {
  //             // @ts-ignore
  //             window.dataLayer = window.dataLayer || [];
  //             // @ts-ignore
  //             if (session !== undefined && session?.data?.newUser2) {
  //               // @ts-ignore
  //               window.dataLayer.push({
  //                 event: 'signup_success',
  //               });
  //             }
  //           }
  //         })
  //         .onComplete(() => {
  //           router.push('https://landrocker.io/command-center?taskId=7a249411-3658-4fd0-b9ae-149cea43b631&isonboarding=step-three');
  //         })
  //         .start(); // Start the onboarding process
  //     } else {
  //       if (router.query.taskId === undefined && router.query.isonboarding === 'step-four' && isLogin) {
  //         intro
  //           .setOptions({
  //             steps: stepFour,
  //             exitOnOverlayClick: false, // Prevent closing on outside click
  //             showBullets: false, // Example of another option
  //             disableInteraction: true, // Prevent interaction with the rest of the page
  //             doneLabel: 'Open',
  //             hidePrev: true,
  //           })
  //           .onComplete(() => {
  //             router.push('https://landrocker.io/command-center?taskId=ad64c150-237b-485e-9304-74c84f23753b&isonboarding=step-five');
  //           })
  //           .start(); // Start the onboarding process
  //       }
  //     }
  //   }, 2000);
  // }, [router.query, isLogin]);

  // Scroll to point list
  const handleScrollToPointList = useCallback(() => {
    if (pointListRef.current) {
      const elementPosition = pointListRef.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }, []);
  return (
    <>
      {/* Main content */}
      <div className={styles.container}>
        {metaTags && <HeadPage title={metaTags.title} description={metaTags.description} imageUrl={metaTags.imageUrl} isHome={metaTags.isHome} />}
        <div
          className='fixed top-0 left-0 w-[100vw] h-[100vh]'
          style={{
            background: 'linear-gradient(170deg, rgba(0,0,0,1) 19%, rgba(5,32,40,1) 50%, rgba(0,0,0,1) 77%)',
          }}
        ></div>
        <div className='w-full z-[1] flex flex-col lg:flex-row gap-x-3 relative mx-auto justify-center '>
          {isReady && (
            <>
              <LeftBox onClick={handleScrollToPointList} />
              <CenterBox pointListRef={pointListRef} />
              <RightBox />
            </>
          )}
        </div>
      </div>
      <EarlyAccessTelegram />
    </>
  );
};

// Static props for the page
export async function getStaticProps(context) {
  const { locale } = context;
  try {
    return {
      props: {
        // ...(await serverSideTranslations(locale ?? 'en')),
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error('Error fetching command center announcement bar:', error);
    return {
      props: {
        // ...(await serverSideTranslations(locale ?? 'en')),
      },
    };
  }
}

export default Achievements;
